import React from "react";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export default function AlertIcon() {
  return <FontAwesomeIcon icon={faExclamationCircle as IconProp} />;
}
